import React from 'react';

const SvgNegativeEvolution = (props) => (
  <svg width={8} height={8} {...props}>
    <path
      fill="#e25d34"
      fillRule="evenodd"
      stroke="#e25d34"
      strokeWidth={0.5}
      d="M.593 1.22l5.493 5.39h-3.18v.59h4.205V3.073h-.6v3.12L1.014.8z"
    />
  </svg>
);

export default SvgNegativeEvolution;
